import type { Video } from "@/model/videos";

type VideoUpNextItemProps = {
  video: Video;
  onSelect: () => void;
  testId?: string;
};

/** Compact row in the player's "up next" column: thumbnail left, details right. */
const VideoUpNextItem = ({ video, onSelect, testId }: VideoUpNextItemProps) => (
  <button
    type="button"
    onClick={onSelect}
    aria-label={`Play ${video.topic}`}
    data-testid={testId}
    className="flex w-full gap-3 rounded-lg p-1.5 text-left transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
  >
    <img
      src={video.thumbNail}
      alt=""
      className="aspect-video w-40 shrink-0 rounded-lg bg-muted object-cover"
    />
    <div className="min-w-0 py-0.5">
      <p className="line-clamp-2 text-sm font-medium leading-snug">
        {video.topic}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{video.source}</p>
      <p className="text-xs text-muted-foreground">{video.type}</p>
    </div>
  </button>
);

export default VideoUpNextItem;
